module.exports = __webpack_public_path__ + "static/media/saint-laurent.4fa6245a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/saint-laurent.jpg
// module id = 200
// module chunks = 0